import React from 'react'

import {
  Card,
  CardAction,
  CardBody,
  CardContent,
  CardHeader,
  CardMedia
} from './style'

const PartnerOfferCard = ({
  image,
  title,
  content,
  hideAction = false,
  actionLabel,
  onActionPress,
  fullSize = false
}) => {
  const imageData = image?.portrait?.gatsbyImageData || image?.landscape?.gatsbyImageData

  return (
    <Card>
      <CardMedia image={imageData}/>
      <CardBody>
        <CardHeader fullSize={fullSize}>{title}</CardHeader>
        <CardContent fullSize={fullSize} html={content} />
        {!hideAction && <CardAction onClick={onActionPress}>{actionLabel}</CardAction>}
      </CardBody>
    </Card>
  )
}

export default PartnerOfferCard